import type { GetTaskFilesQuery } from 'generated/resources/graphql'
import { GetTaskFilesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type TaskFile = NonNullable<
  NonNullable<GetTaskFilesQuery['tasks']['taskFilesConnection']>['nodes'][number]
>

export type { TaskFile }

interface UseGetTaskFiles {
  files: TaskFile[]
  loading: boolean
  error: Error | undefined
}

export const useGetTaskFiles = (taskId: number): UseGetTaskFiles => {
  const { data, loading, error } = useQuery(GetTaskFilesDocument, {
    variables: { taskId },
  })

  return {
    loading,
    files: data?.tasks.taskFilesConnection.nodes ?? [],
    error,
  }
}
